const getFileExtension = (base64String: string) => {
  const decodedData = atob(base64String);
  let extension = undefined;
  const lowerCase = decodedData.toLowerCase();
  if (lowerCase.indexOf("png") !== -1) extension = "png";
  else if (lowerCase.indexOf("jpg") !== -1 || lowerCase.indexOf("jpeg") !== -1)
    extension = "jpg";
  else if (lowerCase.indexOf("bmp") !== -1) extension = "bmp";
  else extension = "tiff";
  return extension;
};

function openDocument(data: string, dataType: string) {
  const url = blobDocumentUrl(data, dataType);
  const newTab = window.open(url, "_blank");
  newTab?.focus();
  window.URL.revokeObjectURL(url);
}

function downloadDocument(data: string, dataType: string, filename: string) {
  const link = document.createElement("a");
  const url = blobDocumentUrl(data, dataType);
  link.href = url;
  link.download = filename;
  link.target = "_blank";
  link.click();
  link.remove();
  window.URL.revokeObjectURL(url);
}

function blobDocumentUrl(data: string, dataType: string) {
  const arr = _base64ToArrayBuffer(data);
  var file = new Blob([arr], { type: dataType });

  return URL.createObjectURL(file);
}

function _base64ToArrayBuffer(base64: string) {
  var binary_string = window.atob(base64);
  var len = binary_string.length;
  var bytes = new Uint8Array(len);
  for (var i = 0; i < len; i++) {
    bytes[i] = binary_string.charCodeAt(i);
  }
  return bytes.buffer;
}

export {
  getFileExtension,
  openDocument,
  _base64ToArrayBuffer,
  downloadDocument,
};
